import Crud from './crud'
import { request_list, export_list, export_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import configs from '@/configs';
var FileSaver = require('file-saver');
import Vue from 'vue';
var crud = new Crud('payments', ' thanh toán');

const state = {
    ...crud.state,
    history: {
        data: [],
        total: 0
    },
    selected: {
        customer: {},
        bills: [],
        receipts: []
    },
    loading: false
};

const getters = {
    ...crud.getters,
};

const actions = {
    ...crud.actions,
    
    getHistoryList({ commit }, params) {
        return new Promise((resolve, reject) => {
            const historyParams = { ...params, type: 'history' };
            commit('SET_LOADING', true);
            request_list(crud.endpoint, (response) => {
                const data = response.data || [];
                const total = response.total || 0;
                commit('SET_HISTORY_LIST', { data, total });
                commit('SET_LOADING', false);
                resolve({ data, total });
            }, Vue.http, historyParams, this.state.authentication.token);
        });
    },
    
    getPaymentHistoryDetail({ commit }, paymentId) {
        commit('SET_LOADING', true);
        return Vue.http.get(`${configs.API}/api/payments/history/${paymentId}`)
            .then(response => {
                const data = response.data.data;
                commit('SET_LOADING', false);
                return data;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },
    
    processPayment({ commit, dispatch }, payload) {
        commit("setLoading", { loading: true });
        return Vue.http.post(`${configs.API}/api/payments/process/`, payload)
            .then(response => {
                commit("setLoading", { loading: false });
                return response.data;
            })
            .catch(error => {
                commit("setLoading", { loading: false });
                throw error;
            });
    },
    
    saveDraftPayment({ commit }, payload) {
        commit("setLoading", { loading: true });
        return Vue.http.post(`${configs.API}/api/payments/draft/`, payload)
            .then(response => {
                commit("setLoading", { loading: false });
                return response.data;
            })
            .catch(error => {
                commit("setLoading", { loading: false });
                throw error;
            });
    },
    
    getDraftPayment({ commit }, params) {
        commit("setLoading", { loading: true });
        return Vue.http.get(`${configs.API}/api/payments/draft/`, { params })
            .then(response => {
                commit("setLoading", { loading: false });
                return response.data;
            })
            .catch(error => {
                commit("setLoading", { loading: false });
                throw error;
            });
    }
};

const mutations = {
    ...crud.mutations,
    
    SET_HISTORY_LIST(state, { data, total }) {
        state.history.data = data;
        state.history.total = total;
    },
    
    CLEAR_CUSTOMER_DETAIL(state) {
        state.selected = {
            customer: {},
            bills: [],
            receipts: []
        };
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
